{
  "name": "@wix/cli",
  "description": "CLI tool for building Wix sites and applications",
  "version": "1.1.235",
  "bin": {
    "wix": "bin/wix.cjs"
  },
  "dependencies": {
    "@wix/agent-skills": "^1.1.0",
    "node-gyp": "^8.4.1"
  },
  "devDependencies": {
    "@commander-js/extra-typings": "^13.0.0",
    "@types/columnify": "^1.5.4",
    "@types/react": "^18.3.3",
    "@types/semver": "^7.5.8",
    "@vercel/detect-agent": "^1.2.1",
    "@wix/bi-logger-dev-tools-data": "^1.169.0",
    "@wix/cli-account-commands": "workspace:*",
    "@wix/cli-astro-commands": "workspace:*",
    "@wix/cli-auth": "workspace:*",
    "@wix/cli-command-contract": "workspace:*",
    "@wix/cli-core-definitions": "workspace:*",
    "@wix/cli-debug-log": "workspace:*",
    "@wix/cli-env": "workspace:*",
    "@wix/cli-error": "workspace:*",
    "@wix/cli-error-reporting": "workspace:*",
    "@wix/cli-fs": "workspace:*",
    "@wix/cli-http-client-react": "workspace:*",
    "@wix/cli-logger": "workspace:*",
    "@wix/cli-panorama": "workspace:*",
    "@wix/cli-plugin-core": "workspace:*",
    "@wix/cli-site": "workspace:*",
    "@wix/cli-site-live": "workspace:*",
    "@wix/cli-site-old": "workspace:*",
    "@wix/cli-telemetry": "workspace:*",
    "@wix/cli-telemetry-react": "workspace:*",
    "@wix/cli-test-overrides": "workspace:*",
    "@wix/cli-ui-kit": "workspace:*",
    "@wix/cli-user-config": "workspace:*",
    "@wix/cli-version-manager": "workspace:*",
    "@wix/tsup-configs": "workspace:*",
    "chalk": "^5.4.1",
    "columnify": "^1.6.0",
    "commander": "^13.0.0",
    "globby": "^14.1.0",
    "react": "^18.3.1",
    "semver": "^7.6.3",
    "variant": "^3.0.0-dev.27",
    "zod": "^3.24.2"
  },
  "engines": {
    "node": ">= 20.11.0"
  },
  "exports": {
    "./config": {
      "types": "./build/exports/config.d.ts",
      "import": "./build/exports/config.js"
    },
    "./package.json": "./package.json"
  },
  "files": [
    "bin",
    "build",
    "templates",
    "agents"
  ],
  "keywords": [
    "wix",
    "wix-cli"
  ],
  "optionalDependencies": {
    "fsevents": "^2.3.2"
  },
  "perfer": {
    "bundleSize": {
      "files": [
        {
          "glob": "./build/index.js",
          "maxSize": "985kb"
        }
      ]
    }
  },
  "publishConfig": {
    "registry": "https://registry.npmjs.org/",
    "access": "public",
    "versionBumpStrategy": "manual",
    "logLevel": "verbose"
  },
  "scripts": {
    "build": "run -T tsup",
    "build:watch": "run -T build:watch --filter='@wix/cli'",
    "test": "yarn workspace @wix/cli-core-spec run test",
    "test:watch": "yarn workspace @wix/cli-core-spec run test:watch",
    "typecheck": "run -T tsc --noEmit"
  },
  "type": "module",
  "wix": {
    "artifact": {
      "groupId": "com.wixpress.npm",
      "artifactId": "wix-cli"
    },
    "validations": {
      "postBuild": [
        "typecheck"
      ]
    }
  }
}
